import { getStateAbbr } from '@vibesites/runtime';

/**
 * Weidner only surfaces Qualifying Criteria on Washington properties
 * (state fair-housing / disclosure requirements). Everywhere else the
 * page and header CTAs stay hidden.
 */
export function isWashingtonState(state: string | null | undefined): boolean {
  if (!state) return false;
  return getStateAbbr(state.trim()) === 'WA';
}
